import type {StockPanelProps} from '@Panels/stock-panel/stock-panel';

export type StockMediaPopupOverrides = Partial<StockPanelProps>;
export type StockMediaPopupOpener = (overrides: StockMediaPopupOverrides) => void;
export type StockMediaPopupCloser = () => void;

let activeOpener: StockMediaPopupOpener | null = null;
let pendingOverrides: StockMediaPopupOverrides | null = null;

const activeClosers = new Set<StockMediaPopupCloser>();

export function registerStockMediaPopupOpener(opener: StockMediaPopupOpener): () => void {
  activeOpener = opener;
  if (pendingOverrides) {
    opener(pendingOverrides);
    pendingOverrides = null;
  }
  return (): void => {
    if (activeOpener === opener) {
      activeOpener = null;
    }
  };
}

export function registerStockMediaPopupCloser(closer: StockMediaPopupCloser): () => void {
  activeClosers.add(closer);
  return (): void => {
    activeClosers.delete(closer);
  };
}

export function openStockMediaPopup(overrides: StockMediaPopupOverrides): void {
  if (activeOpener) {
    activeOpener(overrides);
    return;
  }
  pendingOverrides = overrides;
}

export function closeStockMediaPopup(): void {
  activeClosers.forEach((closer) => {
    closer();
  });
}
